import * as React from 'react';

import { IconPlusSmall } from '@tock/icons';
import { PlainButton } from 'omakase';

interface Props {
  onClick(): void;
  itemText: string;
  isDisabled?: boolean;
}

export const AddButton: React.FunctionComponent<Props> = ({ onClick, itemText, isDisabled }) => {
  return (
    <PlainButton
      variant="primary"
      size="small"
      iconStart={<IconPlusSmall />}
      onClick={onClick}
      disabled={isDisabled}
      aria-label={`Add ${itemText}`}
      className="AddButton"
    >
      Add {itemText}
    </PlainButton>
  );
};
